var _polygon, _polygon2, _path, _line, _text, _text2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "50,13 86,33 86,78 50,97 14,78 14,33",
    fill: "#00BFA5"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "50,21 79,37 79,73 50,90 22,73 22,37",
    fill: "#000000",
    opacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50,22 L55,48 L76,60 L72,65 L54,57 L53,74 L60,80 L56,84 L50,78 L44,84 L40,80 L47,74 L46,57 L28,65 L24,60 L45,48 Z",
    fill: "#ffffff"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 112,
    y1: 13,
    x2: 112,
    y2: 97,
    stroke: "#00BFA5",
    strokeWidth: 2.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 126,
    y: 48,
    fontFamily: "Orbitron, sans-serif",
    fontWeight: 700,
    fontSize: 32,
    fill: "#1A2E2B",
    textLength: 210,
    lengthAdjust: "spacing"
  }, "ATLANTIC")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 126,
    y: 84,
    fontFamily: "Orbitron, sans-serif",
    fontWeight: 400,
    fontSize: 32,
    fill: "#00BFA5",
    textLength: 210,
    lengthAdjust: "spacing"
  }, "CARGO")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.c8589f100d507aa7381398bc2b4ce9bd.svg";
export { ForwardRef as ReactComponent };